module.exports = __webpack_public_path__ + "img/475-ad1041.png";